import { IMultiSelectOptions } from "@starrez/starryui";
import { DynamicTextContextEnum } from "../../enums/DynamicTextContext";
import { WizardTypeEnum } from "../../enums/WizardTypeEnum";
import { validateEmailAddress } from "../../utils/EmailValidator";
import { IAddressTypes, IEntryAddressType, IFromAddress, IMergeTags } from "./graphQL/types";

export interface IAdvancedEmailWizardContext {
    IsLoading: boolean;
    WizardType: WizardTypeEnum;
    DynamicTextContext: DynamicTextContextEnum;
    AddressTypes?: IAddressTypes;
    MergeTagData?: IMergeTags;
    FeatureFlags?: { [flag: string]: boolean; }
}

export interface IAdvancedEmailWizardContextProviderProps extends IAdvancedEmailWizardContext {
    children: React.ReactNode;
}

export function mapEntryAddressTypeToItems(addressTypes?: IEntryAddressType[], data?: Array<string | number>): IMultiSelectOptions[] {
    const items: IMultiSelectOptions[] = [];

    if (data && addressTypes) {
        for (let index = 0; index < data.length; index++) {
            const dataItem = data[index] as string;
            const dataID = Number(dataItem);
            const selectedAddressType = addressTypes.find((addressType) => addressType.id === dataItem || addressType.id === dataID);

            if (isNaN(dataID) && validateEmailAddress(dataItem) && !selectedAddressType) { // if is an email address or free typed DT
                items.push({
                    label: dataItem,
                    value: dataItem,
                });
            } else if (!isNaN(dataID) && selectedAddressType) { // if is an entry address type
                items.push({
                    label: selectedAddressType!.description,
                    value: `${selectedAddressType!.id}`,
                });
            } else if (isNaN(dataID) && selectedAddressType) { // if is an additional dynamic address type
                items.push({
                    label: selectedAddressType!.description,
                    value: `${selectedAddressType!.id}`,
                });
            }
        }
    }

    return items;
}

export function mapFromAddressTypeToItem(addressTypes?: IFromAddress[], fromAddressID?: number): IMultiSelectOptions | null {
    if (isNaN(fromAddressID!) || fromAddressID! < 0 || !addressTypes) {
        return null;
    }

    const selectedAddressType = addressTypes.find((at) => Number(at.id) === fromAddressID);
    if (!selectedAddressType) {
        return null;
    }

    return {
        label: selectedAddressType.description,
        value: `${selectedAddressType.id}`,
    };
}

export * from "./AdvancedEmailWizardContext";
